import React, {useCallback, useEffect, useState, useRef, useMemo} from 'react';
import styles from '../css/index.module.scss';
import sendRequest from "../../../helpers/sendRequest";
import Api from "../../../api";
import LoadingModal from "../../../components/LoadingModal";
import moment from "moment";
import {RESERVE_STATUSES} from "../../../constants/statuses";
import ColorfulTag from "../../../components/ColorfulTag";
import {useAtom} from "jotai/index";
import {reservesInfoAtom} from "../../../atoms/reservesAtoms";

const ReserveStatusesModal = ({reserveId, isVisible}) => {
    const [statuses, setStatuses] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const hasLoadedRef = useRef(false);

    const [reservesInfo] = useAtom(reservesInfoAtom);

    const statusesMap = useMemo(() => {
        return (statuses || []).reduce((acc, item) => ({...acc, [item.id]: reservesInfo?.statuses?.find(i => i.id === item.reservation_status_id) }), {});
    }, [reservesInfo?.statuses, statuses])

    const getStatuses = useCallback(async () => {
        const data = await sendRequest({
            request: Api.getReserveStatusesHistory,
            payload: {id: reserveId},
            setLoading: setLoading,
            warnErrorText: 'while getting reserve statuses',
        })

        if (data?.status === 'ok') {
            setStatuses(data.data.statusesHistory || []);
        } else {
            setError(data?.message || 'Ошибка при получении истории статусов')
        }

        hasLoadedRef.current = true;
    }, [reserveId])

    useEffect(() => {
        if (isVisible && hasLoadedRef.current === false) {
            getStatuses().then();
        }
    }, [isVisible]);

    return (
        <div className={styles.statusesModal}>
            {loading ? (
                <LoadingModal size={50} />
            ) : error ? (
                <p className={styles.errorText}>{error}</p>
            ) : statuses.length > 0 ? (
                statuses.map((item) => (
                    <div key={item.id} className={styles.statusItem}>
                        <ColorfulTag
                            text={statusesMap[item.id]?.name}
                            colorMode={RESERVE_STATUSES[statusesMap[item.id]?.tag]?.colorMode}
                        />
                        <p>{moment(item.created_at).format('HH:mm DD.MM.YYYY')}</p>
                    </div>
                ))
            ) : (
                <p className={styles.emptyText}>Пусто.</p>
            )}
        </div>
    );
};

export default ReserveStatusesModal;
